import React from "react";
import _ from "underscore";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Location } from "history";
import { LocationImageGalleryDialog } from './../../../../shared/components/locationImageGalleryDialog';

import { apiPromiseHook } from "../../../../shared/flux/actions/enterHooks";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import { EnterHookPromises } from "../../../state/enterHookPromises";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface OwnProps {
  location: Location;
}

interface StateProps {
  currentLocationImage: IState<IAccomodationLocationImage>;
  region: IState<ILocation>;
}

interface DispatchProps {
  backToGallery: (regionSlug: string) => void;
  imageClicked: (regionSlug: string, fileName: string) => void;
}

type Props = OwnProps & DispatchProps & StateProps;

export class RegionGalleryDialogComponent extends React.Component<Props, {}> {
  private onGalleryClose(regionSlug: string): void {
    GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Close Gallery");
    this.props.backToGallery(regionSlug);
  }
  render() {
    const region = this.props.region.data;
    const { pathname } = this.props.location;
    const fileName = _.last((pathname as string).split('/'));
    return (
      <div>
        {this.props.currentLocationImage.data &&
          <Helmet title={this.props.currentLocationImage.data.meta}
            meta={[
              { name: "description", content: this.props.currentLocationImage.data.description }
            ]}
          />
        }

        <LocationImageGalleryDialog
          isOpen={true}
          selectedImageFileName={fileName}
          onGalleryClosed={() => this.onGalleryClose(this.props.region.data.slug)}
          prevClicked={(im) => this.props.imageClicked(this.props.region.data.slug, im.fileName)}
          nextClicked={(im) => this.props.imageClicked(this.props.region.data.slug, im.fileName)}
          imageClicked={(im) => this.props.imageClicked(this.props.region.data.slug, im.fileName)}
          title={`${region.name} gallery`}
          images={region.images} />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    backToGallery: (regionSlug: string) => dispatch(push(WebRoutes.regionGallery(regionSlug))),
    imageClicked: (regionSlug: string, fileName: string) =>
      dispatch(push(WebRoutes.regionGalleryImage(regionSlug, fileName)))
  }
}

const mapStateToProps = (state: IWebStoreState): StateProps => {
  return {
    region: state.region,
    currentLocationImage: state.currentLocationImage
  }
}

export const RegionGalleryDialog = connect(mapStateToProps, mapDispatchToProps)(RegionGalleryDialogComponent);

export const regionGalleryDialogOnEnter = apiPromiseHook<unknown>(EnterHookPromises.imageByFileName("fileName"));
